import Registry from "@folo/store/src";

export default (function init() {
  const registry = new Registry();

  return registry;
})();
